import { Link, useLocation } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'
import { getDashboardBreadcrumbItems } from './dashboardBreadcrumbModel'
import { useDashboardBreadcrumb } from './DashboardBreadcrumbContext'

const DASH_CRUMB =
  'shrink-0 text-[rgb(21_151_255)] transition hover:underline cursor-pointer'

export function DashboardBreadcrumbs() {
  const location = useLocation()
  const { pageTitle } = useDashboardBreadcrumb()
  const items = getDashboardBreadcrumbItems(location.pathname, pageTitle)

  if (items.length === 0) {
    return null
  }

  return (
    <nav
      aria-label="Breadcrumb"
      className="border-b border-slate-200/80 bg-white/90 px-4 py-2.5 sm:px-6"
    >
      <ol className="flex flex-wrap items-center gap-x-1.5 gap-y-1 text-sm text-slate-600">
        {items.map((item, i) => {
          const isLast = i === items.length - 1
          const key = `${i}-${item.to ?? 'here'}-${item.label}`
          const inApp = !isLast && item.to != null

          return (
            <li
              key={key}
              className="inline-flex min-w-0 max-w-full items-center gap-1.5"
            >
              {i > 0 && (
                <ChevronRight
                  className="h-3.5 w-3.5 shrink-0 text-slate-400"
                  aria-hidden
                />
              )}
              {inApp ? (
                <Link to={item.to!} className={DASH_CRUMB}>
                  {item.label}
                </Link>
              ) : (
                <span
                  className={
                    isLast
                      ? 'min-w-0 truncate font-medium text-slate-900'
                      : 'shrink-0'
                  }
                >
                  {item.label}
                </span>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
